export default __webpack_public_path__ + "static/media/icon.military socks.463cb621.svg";